document.addEventListener("DOMContentLoaded", () => {

  const popup = document.getElementById("welcome-popup");
  const closeButton = document.querySelector(".popup-close");

  if (!popup) return;

  popup.style.display = "flex";

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      popup.style.display = "none";
    });
  }

});